// extracted by mini-css-extract-plugin
module.exports = {"badge":"c6e8ba5398--badge--E3tVd"};